import PropTypes from "prop-types";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {usermoduleListViewApi} from "store/slices/usermoduleSlice";
import NoStaffAccessPage from "pages/NoStaffAccessPage";
import {visibleMenuModules} from "auth/authSafety";

const modulePaths = new Set(["dashboard", "calendar", "waitlist", "sales", "vouchers", "discount-codes", "subscriptions", "packages", "clients", "staff", "services", "products", "reports", "marketing", "resource", "resources", "settings"]);
const aliases = {"birthday-drip-campaign":"marketing", "appointment-campaign":"marketing", "review-campaign":"marketing", "campaign-daily-logs":"marketing", academyarticle:"marketing", resources:"resource"};
export default function ModuleAccessGuard({children}) {
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const user = useSelector(state => state.auth.user);
  const menu = useSelector(state => state.usermodule.isListView);
  const status = useSelector(state => state.usermodule.isApiStatus?.usermoduleListViewApi);
  const owner = user?.is_owner === true || user?.is_owner === 1;
  const segment = pathname.split('/').filter(Boolean)[0] || '';
  const route = aliases[segment] || segment;
  const protectedRoute = modulePaths.has(route);
  useEffect(() => {
    if (!owner && protectedRoute && !status) dispatch(usermoduleListViewApi());
  }, [dispatch, owner, protectedRoute, status]);
  if (owner || !protectedRoute) return children;
  if (!status || status === "loading") return <div role="status">Loading permissions…</div>;
  const allowed = status === "succeeded" && visibleMenuModules(menu).some(module =>
    String(module.route || '').replace(/^\/+|\/+$/g, '') === route &&
    ![false, 0, "0"].includes(module.is_access) && ![false, 0, "0"].includes(module.access));
  if (!allowed) return <NoStaffAccessPage />;
  return children;
}

ModuleAccessGuard.propTypes = {
  children: PropTypes.node,
};
